import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import axios from 'axios';

const API =  process.env.REACT_APP_API_URL;

export default function PaymentCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const [status, setStatus] = useState('Verifying payment…');

  useEffect(() => {
    const reference = searchParams.get('reference') || searchParams.get('transaction_ref');
    console.log('Callback reference:', reference); 
    if (!reference) {
      setStatus('No payment reference found.');
      return;
    }

    axios.get(`${API}/api/squad/verify/${reference}`)
      .then(res => {
        // In the success block of useEffect, change:
if (res.data.status === 'PAID') {
  setStatus('Payment successful! Redirecting to order confirmation…');
  clearCart();
  setTimeout(() => navigate(`/order-success?reference=${reference}`), 2000);
} else {
          setStatus('Payment verification failed. Please contact support.');
        }
      })
      .catch(() => {
        setStatus('Verification error. Please contact support.');
      });
  }, [searchParams, navigate, clearCart]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center">
      <h2 className="text-2xl font-bold mb-4">Payment Status</h2>
      <p className="text-gray-600">{status}</p>
    </div>
  );
}